import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const GoalEmergencyFund: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        // Override viewBox & strokeWidth, since this is a solid icon
        <IconSVG viewBox="0 0 20 20" strokeWidth={0} {...props}>
            <IconPath
                fill="currentColor"
                d="M16 16c.552 0 1.008-.45.923-.996a6.5 6.5 0 0 0-12.846 0c-.085.545.37.996.923.996h11Z"
                {...pathProps}
            />
            <IconPath
                fill="currentColor"
                d="M5 3c-.552 0-1.008.45-.923.996a6.5 6.5 0 0 0 12.846 0C17.008 3.45 16.553 3 16 3H5Z"
                {...pathProps}
            />
        </IconSVG>
    );
};
